import { ApiResponse, ChangeRecipeResponse } from "../Models";
export const ChangeRecipeMockup: ApiResponse<ChangeRecipeResponse> = {
    statusCode: 200,
    error: null,
    data: {
        currentDayReleaseRemainValues: [],
        releaseGraphValues: [
            {
                nutrient: [
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "N",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "P",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "K",
                    },
                ],
                month: 0,
                index: 0,
            },
            {
                nutrient: [
                    {
                        releaseValues: [
                            {
                                value: 2.5916,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 2.5916,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "N",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "P",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "K",
                    },
                ],
                month: 0,
                index: 1,
            },
            {
                nutrient: [
                    {
                        releaseValues: [
                            {
                                value: 14.4436,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 14.4436,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "N",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "p",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "K",
                    },
                ],
                month: 0,
                index: 2,
            },
            {
                nutrient: [
                    {
                        releaseValues: [
                            {
                                value: 39.3393,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 39.3393,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "N",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "P",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "K",
                    },
                ],
                month: 0,
                index: 3,
            },
            {
                nutrient: [
                    {
                        releaseValues: [
                            {
                                value: 55.4767,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 55.4767,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "N",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "P",
                    },
                    {
                        releaseValues: [
                            {
                                value: 0,
                                mesurmentUnitCode: "1",
                                mesurmentUnit: "Kg/Ha",
                            },
                            {
                                value: 0,
                                mesurmentUnitCode: "2",
                                mesurmentUnit: "ST/Acre",
                            },
                        ],
                        name: "K",
                    },
                ],
                month: 0,
                index: 4,
            },
        ],
        formula: {
            n: 41,
            p: 0,
            k: 0,
        },
        coatingPrecentage: {
            n: 100,
            p: 0,
            k: 0,
        },
        solutionFormula: "MULTICOTE AGRI 4M 20-20-20",
    },
};
